import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Form from 'components/form';
import Checkbox from 'components/form/Checkbox';
import RadioGroup from 'components/form/RadioGroup';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const ChoiceForm = React.forwardRef(
  ({ options, multiple, onChange, value, helpText, hasError }, ref) => {
    const handleChange = (e, val) => {
      if (value) {
        if (value.some((i) => i.value === val.value)) {
          onChange(value.filter((i) => val.value !== i.value));
        } else {
          onChange(value ? [...value, val] : [val]);
        }
      } else {
        onChange([val]);
      }
    };

    if (!multiple) {
      return (
        <RadioGroup
          options={options}
          value={value?.value}
          onChange={(e) =>
            onChange(options.find((i) => i.value === e.target.value))
          }
        />
      );
    }
    return (
      <Grid container columnSpacing={2} rowSpacing={0}>
        {options.map((option) => (
          <Grid item xs={12} sm={6} key={option.value}>
            <Checkbox
              value={option.value}
              margin="none"
              label={option.label}
              checked={
                Array.isArray(value)
                  ? value.find((val) => option.value === val.value)
                  : false
              }
              onChange={(e) => handleChange(e, option)}
            />
          </Grid>
        ))}
      </Grid>
    );
  },
);

const Choice = ({ id, required, options, settings }) => {
  const { getFieldDecorator } = useForm();

  return (
    <>
      <Typography gutterBottom color="text.secondary">
        Select from the following options
      </Typography>
      <FormItem>
        {getFieldDecorator(id, {
          rules: [{ required, message: 'Required' }],
        })(<ChoiceForm multiple={settings.multipleChoice} options={options} />)}
      </FormItem>
    </>
  );
};

export default Choice;
